/**
 * Google Tag Manager E-commerce tracking functions
 */
(function($) {
    'use strict';

    var CART_REFRESH_EVENTS = 'wc_fragments_loaded wc_fragments_refreshed updated_wc_div';
    var isRefreshingCartData = false;

    function toStringSafe(value) {
        if (value === null || typeof value === 'undefined') {
            return '';
        }

        return String(value);
    }

    function cloneItemData(item) {
        if (!item) {
            return null;
        }

        try {
            return JSON.parse(JSON.stringify(item));
        } catch (err) {
            return $.extend(true, {}, item);
        }
    }

    function getRegisteredItemData(candidates) {
        if (!Array.isArray(candidates)) {
            candidates = [candidates];
        }

        var map = window.globberProductData || {};

        for (var i = 0; i < candidates.length; i++) {
            var key = candidates[i];
            if (key === null || typeof key === 'undefined') {
                continue;
            }

            key = toStringSafe(key);

            if (map[key]) {
                return cloneItemData(map[key]);
            }
        }

        return null;
    }

    function getCartItemData(candidates) {
        if (typeof globberAnalytics === 'undefined' || !Array.isArray(globberAnalytics.cartItems)) {
            return null;
        }

        if (!Array.isArray(candidates)) {
            candidates = [candidates];
        }

        for (var i = 0; i < candidates.length; i++) {
            var candidate = candidates[i];
            if (candidate === null || typeof candidate === 'undefined') {
                continue;
            }

            var candidateId = toStringSafe(candidate);

            var match = globberAnalytics.cartItems.find(function(item) {
                return toStringSafe(item.item_id) === candidateId;
            });

            if (match) {
                return cloneItemData(match);
            }
        }

        return null;
    }

    function mergeItemData(baseItem, overrides) {
        var merged = $.extend(true, {}, baseItem || {});
        if (overrides) {
            merged = $.extend(true, merged, overrides);
        }

        return merged;
    }

    function updateProductDataMap(newData) {
        if (!newData) {
            return;
        }

        window.globberProductData = $.extend(true, {}, window.globberProductData || {}, newData);
    }

    function refreshCartAnalyticsData() {
        if (typeof globberAnalytics === 'undefined') {
            return;
        }

        if (!globberAnalytics.ajaxUrl || isRefreshingCartData) {
            return;
        }

        isRefreshingCartData = true;

        $.ajax({
            url: globberAnalytics.ajaxUrl,
            method: 'POST',
            dataType: 'json',
            data: { action: 'globber_get_cart_datalayer' }
        }).done(function(response) {
            if (!response || !response.success || !response.data) {
                return;
            }

            var data = response.data;

            globberAnalytics.cartItems = Array.isArray(data.items) ? data.items : [];

            if (typeof data.cartTotal !== 'undefined') {
                globberAnalytics.cartTotal = parseFloat(data.cartTotal);
            }

            if (typeof data.cartTax !== 'undefined') {
                globberAnalytics.cartTax = parseFloat(data.cartTax);
            }

            if (typeof data.cartShipping !== 'undefined') {
                globberAnalytics.cartShipping = parseFloat(data.cartShipping);
            }

            if (data.productData) {
                updateProductDataMap(data.productData);
            }
        }).always(function() {
            isRefreshingCartData = false;
        });
    }

    $(document.body).on(CART_REFRESH_EVENTS, refreshCartAnalyticsData);
    
    // Track add to cart events
    $(document).on('added_to_cart', function(event, fragments, cart_hash, $button) {
        if (typeof dataLayer === 'undefined') return;
        if (typeof globberAnalytics === 'undefined') return;
        
        // Get base product data from the button's data attributes
        var productId = $button.data('product_id');
        var productSku = $button.data('product_sku');
        var productName = $button.data('product_name');
        var productPrice = $button.data('product_price');
        var productCategory = $button.data('product_category');
        var productBrand = $button.data('product_brand');
        
        // Check for variable product data
        var $form = $button.closest('form.variations_form, form.cart');
        var quantityData = $button.data('quantity');
        var formQuantityInput = $form.length ? $form.find('input.qty, input[name="quantity"]').first() : $();
        var formQuantity = formQuantityInput.length ? formQuantityInput.val() : null;
        var quantity = parseInt(quantityData || formQuantity || 1, 10);

        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }
        var variationId = $form.find('input[name="variation_id"]').val();
        var itemVariant = '';
        var actualPrice = productPrice;
        var actualSku = productSku || productId;
        
        // If this is a variable product with a selected variation
        if (variationId && variationId > 0) {
            // Try to get variation data from the form
            var $variationForm = $form.closest('.variations_form');
            
            if ($variationForm.length) {
                // Get the variation data
                var variations = $variationForm.data('product_variations');
                
                if (variations && Array.isArray(variations)) {
                    var selectedVariation = variations.find(function(v) {
                        return v.variation_id == variationId;
                    });
                    
                    if (selectedVariation) {
                        // Use variation SKU if available
                        if (selectedVariation.sku) {
                            actualSku = selectedVariation.sku;
                        } else if (selectedVariation.variation_id) {
                            actualSku = String(selectedVariation.variation_id);
                        } else {
                            actualSku = String(variationId);
                        }
                        
                        // Use variation price
                        if (selectedVariation.display_price) {
                            actualPrice = selectedVariation.display_price;
                        }
                        
                        // Build variant string from attributes
                        if (selectedVariation.attributes) {
                            var variantParts = [];
                            
                            // Get attribute labels from the form
                            $variationForm.find('.variations select').each(function() {
                                var $select = $(this);
                                var selectedValue = $select.val();
                                
                                if (selectedValue) {
                                    // Get the readable label
                                    var selectedText = $select.find('option:selected').text();
                                    if (selectedText && selectedText !== '') {
                                        variantParts.push(selectedText);
                                    }
                                }
                            });
                            
                            if (variantParts.length > 0) {
                                itemVariant = variantParts.join(' / ');
                            }
                        }
                    }
                }
            }
        }
        
        var priceNumber = parseFloat(actualPrice);
        if (isNaN(priceNumber)) {
            priceNumber = 0;
        }

        var idCandidates = [];
        if (actualSku) {
            idCandidates.push(actualSku);
        }
        if (variationId) {
            idCandidates.push(variationId);
        }
        if (productSku) {
            idCandidates.push(productSku);
        }
        if (productId) {
            idCandidates.push(productId);
        }

        var baseItem = getRegisteredItemData(idCandidates) || getCartItemData(idCandidates);

        var itemOverrides = {
            quantity: quantity,
            price: priceNumber
        };

        if (itemVariant) {
            itemOverrides.item_variant = itemVariant;
        }

        if (productName && (!baseItem || !baseItem.item_name)) {
            itemOverrides.item_name = productName;
        }

        if (productBrand && (!baseItem || !baseItem.item_brand)) {
            itemOverrides.item_brand = productBrand;
        }

        if (productCategory && (!baseItem || !baseItem.item_category)) {
            itemOverrides.item_category = productCategory;
        }

        var item = mergeItemData(baseItem, itemOverrides);

        if (!item.item_id) {
            item.item_id = toStringSafe(actualSku || productSku || productId);
        }

        if (!item.item_name && productName) {
            item.item_name = productName;
        }

        if (!item.item_brand && productBrand) {
            item.item_brand = productBrand;
        }

        if (!item.item_category && productCategory) {
            item.item_category = productCategory;
        }

        var currency = (typeof globberAnalytics !== 'undefined' && globberAnalytics.currency) ? globberAnalytics.currency : item.currency;
        item.currency = currency || '';

        if (!item.affiliation) {
            item.affiliation = window.location.hostname;
        }

        item.quantity = quantity;
        item.price = priceNumber;

        var eventValue = item.price * item.quantity;

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                currency: item.currency,
                value: eventValue,
                items: [item]
            }
        });

    });
    
    // Track begin_checkout events
    // Use capture phase to ensure we catch the click even if propagation is stopped by other scripts
    document.addEventListener('click', function(e) {
        var $target = $(e.target);
        var $button = $target.closest('.checkout-button, .wc-proceed-to-checkout .button');
        
        if ($button.length) {
            console.log('Globber Analytics: Checkout button clicked');

            if (typeof dataLayer === 'undefined') {
                console.warn('Globber Analytics: dataLayer is undefined');
                return;
            }
            if (typeof globberAnalytics === 'undefined') {
                console.warn('Globber Analytics: globberAnalytics is undefined');
                return;
            }
            
            var currency = globberAnalytics.currency || '';
            var cartItems = Array.isArray(globberAnalytics.cartItems) ? globberAnalytics.cartItems : [];
            var cartValue = parseFloat(globberAnalytics.cartTotal);
            if (isNaN(cartValue)) {
                cartValue = 0;
            }

            console.log('Globber Analytics: Pushing begin_checkout event', {
                currency: currency,
                value: cartValue,
                items: cartItems
            });

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'begin_checkout',
                ecommerce: {
                    currency: currency,
                    value: cartValue,
                    items: cartItems
                }
            });
        }
    }, true);
    
    // Track product clicks (select_item)
    $(document).on('click', '.product-card__link, .woocommerce-LoopProduct-link', function() {
        if (typeof dataLayer === 'undefined') return;
        
        var $productCard = $(this).closest('.product-card, .product');
        
        var productId = $productCard.find('[data-product_id]').first().data('product_id');
        var productSku = $productCard.find('[data-product_sku]').first().data('product_sku');
        var productName = $productCard.find('.product-card__title, .woocommerce-loop-product__title').first().text().trim() || '';

        var idCandidates = [];
        if (productSku) {
            idCandidates.push(productSku);
        }
        if (productId) {
            idCandidates.push(productId);
        }

        var item = getRegisteredItemData(idCandidates) || getCartItemData(idCandidates);

        if (!item) {
            if (!productId && !productName) {
                return;
            }
            item = {
                item_id: toStringSafe(productSku || productId),
                item_name: productName || ''
            };
        }

        if (!item.item_id) {
            item.item_id = toStringSafe(productSku || productId);
        }

        if (!item.item_name && productName) {
            item.item_name = productName;
        }

        if (!item.item_id) {
            return;
        }

        item.quantity = 1;

        var currency = (typeof globberAnalytics !== 'undefined' && globberAnalytics.currency) ? globberAnalytics.currency : item.currency;
        item.currency = currency || '';

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'select_item',
            ecommerce: {
                currency: item.currency,
                items: [item]
            }
        });
    });
    
    // Track remove from cart
    $(document).on('click', '.remove_from_cart_button', function(e) {
        if (typeof dataLayer === 'undefined') return;
        if (typeof globberAnalytics === 'undefined') return;
        
        var $button = $(this);
        var productId = $button.data('product_id');
        var productSku = $button.data('product_sku');
        var productName = $button.closest('.woocommerce-mini-cart-item, .cart_item').find('.product-name, .woocommerce-mini-cart-item__title').first().text().trim();

        var idCandidates = [];
        if (productSku) {
            idCandidates.push(productSku);
        }
        if (productId) {
            idCandidates.push(productId);
        }

        var cartItem = getCartItemData(idCandidates);
        var baseItem = getRegisteredItemData(idCandidates) || cartItem;

        if (!baseItem && !productId && !productSku) {
            return;
        }

        var quantity = cartItem && cartItem.quantity ? parseInt(cartItem.quantity, 10) : 1;
        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }

        var price = cartItem && cartItem.price ? parseFloat(cartItem.price) : null;
        if (price === null && baseItem && baseItem.price) {
            price = parseFloat(baseItem.price);
        }

        if (isNaN(price) || price < 0) {
            price = 0;
        }

        var fallbackItem = {
            item_id: toStringSafe(productSku || productId),
            item_name: productName || ''
        };

        var item = mergeItemData(baseItem || fallbackItem, {
            item_id: toStringSafe((baseItem && baseItem.item_id) || productSku || productId),
            item_name: (baseItem && baseItem.item_name) || productName || '',
            quantity: quantity,
            price: price
        });

        if (!item.item_id) {
            return;
        }

        if (!item.item_name && productName) {
            item.item_name = productName;
        }

        var currency = (typeof globberAnalytics !== 'undefined' && globberAnalytics.currency) ? globberAnalytics.currency : item.currency;
        item.currency = currency || '';

        var eventValue = item.price * item.quantity;

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'remove_from_cart',
            ecommerce: {
                currency: item.currency,
                value: eventValue,
                items: [item]
            }
        });

        refreshCartAnalyticsData();
    });
    
    // Track view_cart when cart page loads
    if (typeof globberAnalytics !== 'undefined' && $('body').hasClass('woocommerce-cart')) {
        $(window).on('load', function() {
            if (typeof dataLayer === 'undefined') return;
            
            var currency = globberAnalytics.currency || '';
            var cartItems = Array.isArray(globberAnalytics.cartItems) ? globberAnalytics.cartItems : [];
            var cartValue = parseFloat(globberAnalytics.cartTotal);
            if (isNaN(cartValue)) {
                cartValue = 0;
            }

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'view_cart',
                ecommerce: {
                    currency: currency,
                    value: cartValue,
                    items: cartItems
                }
            });
        });
    }
    
    // Track add to wishlist (if wishlist plugin is active)
    // Listen to the AJAX success event instead of click
    $(document.body).on('alg_wc_wl_toggle_wl_item', function(e) {
        if (typeof dataLayer === 'undefined') return;
        
        // e.target might be a child element (icon/span), so find the actual button
        var $button = $(e.target).closest('button[data-action="alg-wc-wl-toggle"]');
        
        if (!$button.length) {
            $button = $(e.target);
        }
        
        // Only track when adding to wishlist (not removing)
        // The button has class 'remove' AFTER being added to wishlist
        if ($button.hasClass('remove')) {
            return;
        }
        
        var productId = $button.data('item_id') || $button.attr('data-item_id');

        if (!productId) {
            return;
        }

        // Check if this is a variation product
        var variationId = null;
        var variationSku = null;
        var itemVariant = '';
        var $variationForm = $button.closest('.product-details, .product').find('form.variations_form');
        
        if ($variationForm.length) {
            variationId = $variationForm.find('input[name="variation_id"]').val();
            
            if (variationId && variationId > 0) {
                var variations = $variationForm.data('product_variations');
                
                if (variations && Array.isArray(variations)) {
                    var selectedVariation = variations.find(function(v) {
                        return v.variation_id == variationId;
                    });
                    
                    if (selectedVariation) {
                        if (selectedVariation.sku) {
                            variationSku = selectedVariation.sku;
                        }
                        
                        // Build variant string from attributes
                        if (selectedVariation.attributes) {
                            var variantParts = [];
                            
                            $variationForm.find('.variations select').each(function() {
                                var $select = $(this);
                                var selectedValue = $select.val();
                                
                                if (selectedValue) {
                                    var selectedText = $select.find('option:selected').text();
                                    if (selectedText && selectedText !== '') {
                                        variantParts.push(selectedText);
                                    }
                                }
                            });
                            
                            if (variantParts.length > 0) {
                                itemVariant = variantParts.join(' / ');
                            }
                        }
                    }
                }
            }
        }

        // Build ID candidates list with variation SKU as priority
        var idCandidates = [];
        if (variationSku) {
            idCandidates.push(variationSku);
        }
        if (variationId) {
            idCandidates.push(variationId);
        }
        idCandidates.push(productId);
        
        var item = getRegisteredItemData(idCandidates) || getCartItemData(idCandidates);

        // If we have item data from registry, enhance it with variation data if available
        if (item && item.item_id && item.item_name) {
            if (variationSku) {
                item.item_id = toStringSafe(variationSku);
            }
            if (itemVariant) {
                item.item_variant = itemVariant;
            }
            
            var currency = (typeof globberAnalytics !== 'undefined' && globberAnalytics.currency) ? globberAnalytics.currency : item.currency;
            item.currency = currency || '';

            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: 'add_to_wishlist',
                ecommerce: {
                    currency: item.currency,
                    items: [item]
                }
            });
            return;
        }

        // Fallback: try to get data from the product card context
        var $productCard = $button.closest('.product-card, .product, .product-details');
        var productName = '';
        var productPrice = 0;
        
        if ($productCard.length) {
            productName = $productCard.find('.product-card__title, .woocommerce-loop-product__title, h1[itemprop="name"]').first().text().trim();
            var $priceElement = $productCard.find('.woocommerce-Price-amount, .price .amount').first();
            if ($priceElement.length) {
                var priceText = $priceElement.text().replace(/[^0-9.]/g, '');
                productPrice = parseFloat(priceText) || 0;
            }
        }

        // Create basic item data with variation info if available
        var fallbackItem = {
            item_id: toStringSafe(variationSku || productId),
            item_name: productName || '',
            price: productPrice
        };

        if (itemVariant) {
            fallbackItem.item_variant = itemVariant;
        }

        var currency = (typeof globberAnalytics !== 'undefined' && globberAnalytics.currency) ? globberAnalytics.currency : 'USD';
        fallbackItem.currency = currency;

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'add_to_wishlist',
            ecommerce: {
                currency: currency,
                items: [fallbackItem]
            }
        });
    });

    // =========================================================================
    // P2-0: Checkout newsletter opt-in tracking
    // Moved from inlaine PHP so we can re-attach after WooCommerce AJAX refreshes
    // and preserve the user's checked state across DOM replacements.
    // =========================================================================
    if ( $( 'body' ).hasClass( 'woocommerce-checkout' ) ) {
        var newsletterChecked = false;

        function pushNewsletterEvent( checked ) {
            if ( typeof dataLayer === 'undefined' ) return;
            var provider = $( '#checkout_newsletter' )
                .closest( '[data-newsletter-provider]' )
                .data( 'newsletter-provider' ) || '';
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push( {
                event:               'checkout_newsletter_optin',
                newsletter_provider: provider,
                newsletter_optin:    checked,
            } );
        }

        function attachNewsletterListener() {
            var $cb = $( '#checkout_newsletter' );
            if ( ! $cb.length ) return;

            // Restore state that was checked before the AJAX refresh
            $cb.prop( 'checked', newsletterChecked );

            $cb.off( 'change.newsletter' ).on( 'change.newsletter', function () {
                newsletterChecked = this.checked;
                pushNewsletterEvent( this.checked );
            } );
        }

        // Initial attach on page load
        attachNewsletterListener();

        // Re-attach (and restore state) after every WooCommerce AJAX checkout refresh
        $( document.body ).on( 'updated_checkout', attachNewsletterListener );

        // Push the definitive opt-in state when the order is placed
        $( document ).on( 'click', '#place_order', function () {
            var $cb = $( '#checkout_newsletter' );
            if ( $cb.length ) {
                pushNewsletterEvent( $cb.is( ':checked' ) );
            }
        } );
    }

    // =========================================================================
    // P2-1: Checkout funnel — add_shipping_info + add_payment_info
    // =========================================================================
    if ( $( 'body' ).hasClass( 'woocommerce-checkout' ) ) {
        $( document.body ).on( 'updated_checkout', function () {
            if ( typeof dataLayer === 'undefined' ) return;
            if ( typeof globberAnalytics === 'undefined' ) return;

            var selectedMethod = $( 'input[name^="shipping_method"]:checked' ).val();
            if ( ! selectedMethod ) return;

            dataLayer.push( { ecommerce: null } );
            dataLayer.push( {
                event: 'add_shipping_info',
                ecommerce: {
                    currency:      globberAnalytics.currency || '',
                    value:         parseFloat( globberAnalytics.cartTotal ) || 0,
                    shipping_tier: selectedMethod,
                    items:         Array.isArray( globberAnalytics.cartItems ) ? globberAnalytics.cartItems : [],
                },
            } );
        } );

        $( document.body ).on( 'payment_method_selected', function () {
            if ( typeof dataLayer === 'undefined' ) return;
            if ( typeof globberAnalytics === 'undefined' ) return;

            var method = $( 'input[name="payment_method"]:checked' ).val();
            if ( ! method ) return;

            dataLayer.push( { ecommerce: null } );
            dataLayer.push( {
                event: 'add_payment_info',
                ecommerce: {
                    currency:     globberAnalytics.currency || '',
                    value:        parseFloat( globberAnalytics.cartTotal ) || 0,
                    payment_type: method,
                    items:        Array.isArray( globberAnalytics.cartItems ) ? globberAnalytics.cartItems : [],
                },
            } );
        } );
    }

    // =========================================================================
    // P2-2: Promotion tracking helper
    // =========================================================================
    function pushPromoEvent( eventName, element ) {
        if ( typeof dataLayer === 'undefined' ) return;
        dataLayer.push( { ecommerce: null } );
        dataLayer.push( {
            event: eventName,
            ecommerce: {
                items: [ {
                    promotion_id:   element.dataset.promoId       || '',
                    promotion_name: element.dataset.promoName     || '',
                    creative_name:  element.dataset.promoCreative || '',
                    creative_slot:  element.dataset.promoSlot     || '',
                } ],
            },
        } );
    }

    // Top banner: view_promotion on active slide + on rotation, select_promotion on CTA click
    ( function () {
        var $slider = $( '.discount-top__slider' );
        if ( ! $slider.length ) return;

        var firedSlotIds = {};

        function fireViewForSlide( slideEl ) {
            var promoId = slideEl.dataset.promoId;
            if ( ! promoId || firedSlotIds[ promoId ] ) return;
            firedSlotIds[ promoId ] = true;
            pushPromoEvent( 'view_promotion', slideEl );
        }

        // Fire for the initially active slide on DOMContentLoaded / immediately
        var $initial = $slider.find( '.js-promo-slide.is-active' );
        if ( $initial.length ) {
            fireViewForSlide( $initial[ 0 ] );
        }

        // Watch for subsequent slides becoming active (Splide toggles is-active)
        if ( typeof MutationObserver !== 'undefined' ) {
            var bannerObserver = new MutationObserver( function ( mutations ) {
                mutations.forEach( function ( mutation ) {
                    if ( mutation.type === 'attributes' && mutation.attributeName === 'class' ) {
                        var el = mutation.target;
                        if ( el.classList.contains( 'is-active' ) ) {
                            fireViewForSlide( el );
                        }
                    }
                } );
            } );

            $slider.find( '.js-promo-slide' ).each( function () {
                bannerObserver.observe( this, { attributes: true, attributeFilter: [ 'class' ] } );
            } );
        }

        // select_promotion on any link click within a slide
        $slider.find( '.js-promo-slide a' ).on( 'click', function () {
            var slideEl = $( this ).closest( '.js-promo-slide' )[ 0 ];
            if ( slideEl ) {
                pushPromoEvent( 'select_promotion', slideEl );
            }
        } );
    }() );

    // Countdown promo: view_promotion on page load, select_promotion on CTA click
    ( function () {
        var $section = $( '.countdown-promo[data-promo-id]' );
        if ( ! $section.length ) return;

        pushPromoEvent( 'view_promotion', $section[ 0 ] );

        $section.find( '.countdown-promo__cta' ).on( 'click', function () {
            pushPromoEvent( 'select_promotion', $section[ 0 ] );
        } );
    }() );

    // BOGO badges: IntersectionObserver fires view_promotion when badge enters viewport
    ( function () {
        var badges = document.querySelectorAll( '.js-bogo-badge' );
        if ( ! badges.length ) return;
        if ( typeof IntersectionObserver === 'undefined' ) return;

        var bogoObserver = new IntersectionObserver( function ( entries ) {
            entries.forEach( function ( entry ) {
                if ( entry.isIntersecting ) {
                    pushPromoEvent( 'view_promotion', entry.target );
                    bogoObserver.unobserve( entry.target );
                }
            } );
        }, { threshold: 0.5 } );

        badges.forEach( function ( badge ) {
            bogoObserver.observe( badge );
        } );
    }() );

    // =========================================================================
    // P2-4: Scroll depth tracking
    // =========================================================================
    ( function () {
        var thresholds = [ 25, 50, 75, 100 ];
        var fired      = {};

        window.addEventListener( 'scroll', function () {
            var scrolled = window.scrollY + window.innerHeight;
            var total    = document.documentElement.scrollHeight;
            var pct      = Math.round( ( scrolled / total ) * 100 );

            thresholds.forEach( function ( t ) {
                if ( pct >= t && ! fired[ t ] ) {
                    fired[ t ] = true;
                    if ( typeof dataLayer !== 'undefined' ) {
                        dataLayer.push( {
                            event:          'scroll_depth',
                            scroll_percent: t,
                            page_path:      window.location.pathname,
                        } );
                    }
                }
            } );
        }, { passive: true } );
    }() );

})(jQuery);